// ═══════════════════════════════════════════════════════════════════════════
// FRANKY'S FARM - BRAND SYSTEM
// Ben & Jerry's inspired - Playful, Warm, Fun
// ═══════════════════════════════════════════════════════════════════════════

export const BRAND = {
  // ─────────────────────────────────────────────────────────────────────────
  // COLOR PALETTE - From Reference Design
  // ─────────────────────────────────────────────────────────────────────────
  colors: {
    // Backgrounds
    bg: "#F5E6E0",              // Warm beige/pink - MAIN BACKGROUND
    bgCard: "#FFFFFF",
    bgSecondary: "#FFF9F0",
    
    // Primary - Forest Green
    green: "#2D5A3D",
    greenLight: "#4A7C59",
    greenDark: "#1E3D2A",
    
    // Accent - Rust Orange
    orange: "#E07A3D",
    orangeLight: "#F08A4D",
    orangeDark: "#C25D3D",
    
    // Secondary - Tan/Camel
    tan: "#D4A574",
    tanLight: "#E8C49A",
    tanDark: "#B8956A",
    
    // Text
    text: "#1A1A1A",
    textSecondary: "#4A4A4A",
    textMuted: "#6B5B4F",
    textLight: "#FFFFFF",
    
    // Utility
    success: "#2D5A3D",
    warning: "#E07A3D",
    error: "#C25D3D",
    
    // Borders
    border: "#E6DED3",
  },

  // ─────────────────────────────────────────────────────────────────────────
  // TYPOGRAPHY
  // ─────────────────────────────────────────────────────────────────────────
  typography: {
    heading: "'Space Grotesk', sans-serif",
    body: "'Figtree', sans-serif",
  },

  // ─────────────────────────────────────────────────────────────────────────
  // SHADOWS
  // ─────────────────────────────────────────────────────────────────────────
  shadows: {
    sm: "0 2px 8px rgba(0,0,0,0.08)",
    md: "0 4px 16px rgba(0,0,0,0.1)",
    lg: "0 8px 24px rgba(0,0,0,0.12)",
  },

  // ─────────────────────────────────────────────────────────────────────────
  // LOGO
  // ─────────────────────────────────────────────────────────────────────────
  logo: "/logo-frankysfarm.png",
};

export const { colors, typography, shadows, logo } = BRAND;
export default BRAND;
